import React, { Component } from "react";
import {
  ExitToApp,
  Dashboard,
  Book,
  Lock,
  Print,
  PieChart,
  BookSharp
} from "@material-ui/icons";
import { Link, withRouter } from "react-router-dom";
import { removeFromStorage } from "../../utils/storage";
import key from "../../config/key.json";

class Sidebar extends Component {

  logoutHandler = () => {
    removeFromStorage(key.loginInfoKey);
    this.props.history.push("/");
  };
  render() {
    return (
      <div className="sidebar">
        <div
          style={{
            paddingLeft: "15px",
            paddingTop: "30px",
            paddingBottom: "12px",
            backgroundColor: "teal",
            height: "80px",
          }}
        >
          <Link to="/Graph" style={{ textDecoration: "none", color: "white" }}>
            <Dashboard />
          </Link>
        </div>

        <ul>
          <Link to="/Graph" style={{ textDecoration: "none", color: "white" }}>
            <li>
              <PieChart />
              <span> Graph</span>
            </li>
          </Link>
          <Link to="/List" style={{ textDecoration: "none", color: "white" }}>
            <li>
              <Book />
              <span> List</span>
            </li>
          </Link>
          <a href="/#/referring_physician_list" style={{ textDecoration: "none", color: "white" }}>
            <li>
              <BookSharp />
              <span> Referring Physicians</span>
            </li>
          </a>
          <Link to="/Bill" style={{ textDecoration: "none", color: "white" }}>
            <li>
              <Print />
              <span> Bill</span>
            </li>
          </Link>
          <Link
            to="/ChangePassword"
            style={{ textDecoration: "none", color: "white" }}
          >
            <li>
              <Lock />
              <span> Change Password</span>
            </li>
          </Link>

          <li onClick={this.logoutHandler}>
            <ExitToApp />
            <span> Logout</span>
          </li>
        </ul>
      </div>
    );
  }
}

export default withRouter(Sidebar);
